module.exports = __webpack_public_path__ + "static/media/3040165000_01.9edb58f2.jpg";